import defaultSettings from "@/settings"
import axios from "axios"

const { showSettings, fixedHeader, sidebarLogo } = defaultSettings

const state = {
  showSettings: showSettings,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo
}

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    // eslint-disable-next-line no-prototype-builtins
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  }
}

const actions = {
  changeSetting({ commit }, data) {
    commit("CHANGE_SETTING", data)
  },
  checkVersion({ commit, state }) {
    return new Promise(resolve => {
      axios
        .get("/version.json?v=" + new Date().getTime(), { headers: { "Cache-Control": "no-cache" }, baseURL: window.location.origin })
        // 请求json文件的内容, 并且禁止缓存
        .then(res => {
          const latestVersion = res.data.version
          const currentPageVersion = Number(document.querySelector('meta[name="version"]').content || "")
          resolve(latestVersion === currentPageVersion)
        })
        .catch(err => {
          console.log("checkVersion err", err)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
